/**
 * @file コンポーネント：フル動画ページ機器広告問い合わせ確認モーダル ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import { fnPushDataLayerGtm } from "~/src/functions/common";
import { fnSendEventHubspot } from "~/src/functions/hubspot";

// コンポーネントを返す
export const ModalAdConfirm = (props) => {
    /**
     * 同意するボタンクリック時の処理
     */
    const fnOnClickAgree = (e) => {
        // クリックデフォルト処理をキャンセル
        e.preventDefault();
        // 広告症例資料請求フラグの更新APIにPOST
        const api = "/api/AdOperationRequests/updateRequestFlag";
        const options = {
            body: JSON.stringify({ AdOperationId: props.adOperationId }),
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
        };
        fetch(api, options).then((response) => {
            if (response.status === 200) {
                // POST成功時、確認モーダルを閉じて成功モーダルを開く
                props.setIsOpenModalAdConfirm(false);
                props.setIsOpenModalAdSuccess(true);
            } else {
                // POST失敗時、確認モーダルを閉じて失敗モーダルを開く
                props.setIsOpenModalAdConfirm(false);
                props.setIsOpenModalAdFailure(true);
            }
        });
        // HubSpotにイベントを送信
        fnSendEventHubspot({
            name: "pe21169348_ad_agree",
            properties: {
                ad_agree_click: null,
            },
        });
        // Google Tag Manager カスタムイベントトリガー
        fnPushDataLayerGtm({
            event: "SendFlag",
            operationId: window.atob(props.operationId),
            userId: window.dataUser.userId,
        });
    };

    // Presenterに渡す
    return <Presenter {...props} fnOnClickAgree={fnOnClickAgree} />;
};
